import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_HINZUFUEGEN_MULTI = '[BenutzerverwaltungModul] PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMulti laden';
export const POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_HINZUFUEGEN_MULTI_AUSFUEHREN = '[BenutzerverwaltungModul] PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMulti ausführen';
export const POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_HINZUFUEGEN_MULTI_ERFOLGREICH = '[BenutzerverwaltungModul] PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMulti laden erfolgreich';
export const POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_HINZUFUEGEN_MULTI_FEHLER = '[BenutzerverwaltungModul] PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMulti Ladefehler';
export const POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_HINZUFUEGEN_MULTI_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMulti nicht ausgeführt (evtl. Offline)';


export class PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMultiAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_HINZUFUEGEN_MULTI;
        constructor(public rolleMultiRequest: api.RolleMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMultiAusfuehrenAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_HINZUFUEGEN_MULTI_AUSFUEHREN;
        constructor(public rolleMultiRequest: api.RolleMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMultiErfolgreichAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_HINZUFUEGEN_MULTI_ERFOLGREICH;
        constructor(public payload: api.FunktionsbereichIdentifier, public rolleMultiRequest: api.RolleMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMultiFehlerAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_HINZUFUEGEN_MULTI_FEHLER;
        constructor(public payload: any, public rolleMultiRequest: api.RolleMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMultiNichtAusgefuehrtAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_HINZUFUEGEN_MULTI_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMultiActions =
    PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMultiAction
    | PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMultiAusfuehrenAction
    | PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMultiErfolgreichAction
    | PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMultiFehlerAction
    | PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMultiNichtAusgefuehrtAction
    ;
